export default __webpack_public_path__ + "static/media/Rocket.f753eb3e.webp";